import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const CollapseIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '16';
			case SIZE.STANDARD:
				return '24';
			default:
				return '15';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '16';
			case SIZE.STANDARD:
				return '24';
			default:
				return '15';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg
				x="0px"
				y="0px"
				width={getWidth(size)}
				height={getHeight(size)}
				viewBox="0 0 24 24"
				style={{enableBackground: 'new 0 0 24 24'}}
			>
				<g id="Frame_-_24px">
					<rect fill="none" width="24" height="24" />
				</g>
				<g id="Line_Icons">
					<g>
						<polygon fill={color} points="12,13 16,13 16,11 12,11 12,8 7,12 12,16" />
						<rect x="2" y="11" fill={color} width="2" height="2" />
						<rect x="2" y="8" fill={color} width="2" height="2" />
						<rect x="2" y="5" fill={color} width="2" height="2" />
						<rect x="8" y="2" fill={color} width="2" height="2" />
						<rect x="5" y="2" fill={color} width="2" height="2" />
						<rect x="2" y="2" fill={color} width="2" height="2" />
						<rect x="2" y="14" fill={color} width="2" height="2" />
						<rect x="2" y="17" fill={color} width="2" height="2" />
						<rect x="2" y="20" fill={color} width="2" height="2" />
						<rect x="5" y="20" fill={color} width="2" height="2" />
						<rect x="8" y="20" fill={color} width="2" height="2" />
						<polygon fill={color} points="11,2 11,7 13,7 13,4 20,4 20,20 13,20 13,18 11,18 11,22 22,22 22,2" />
					</g>
				</g>
			</svg>
		</StyledSpan>
	);
};

CollapseIcon.SIZE = SIZE;
CollapseIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	opacity: PropTypes.number,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

CollapseIcon.defaultProps = {
	opacity: 1,
};
export const StyledSpan = Styled.span`
	cursor: pointer;
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-items: center;
`;
